import { INewbuilding } from '../../types/newbuilding';

export const isBuilderChatEnabledByNewbuilding = (newbuilding: INewbuilding) => {
  return newbuilding.builders.some(builder => builder.chat?.isEnabled);
};
